<div class="trial-counter-container" *ngIf="taskAnimationComplete">
  <div class="trial-counter-background" [ngStyle]="{'background': ' ' + trialCounterColor + ' '}">
    <div class="trial-counter-left-margin-space"></div>
    <wf-trial-counter-chip *ngFor="let trial of trialStatus" [trialStatus]="trial"></wf-trial-counter-chip>
  </div>
  <div class="trial-counter-avatar" [ngStyle]="{'background-image':'url(' + avatarIcon + ')'}"></div>
</div>
